<div class="header d-none d-md-block">
  <h1 class="d-inline-block v-align-middle">{{ title | translate }}</h1>
  <button class="btn btn-outlined btn-list-header" (click)="onCreateItem()">
    <img src="assets/icons/plus-darker.svg" alt="create" />{{ 'CREATE_BTN' | translate }}
  </button>
</div>
<div class="header d-flex d-md-none align-items-center">
  <h1 class="w-100">{{ title | translate }}</h1>
  <button class="btn btn-outlined btn-list-header" (click)="onCreateItem()">
    <img src="assets/icons/plus-darker.svg" alt="create" />{{ 'CREATE_BTN' | translate }}
  </button>
</div>

<app-filter [filters]="filterDefinition" (change)="onFilterChange($event)" [defaultFilters]="defaultFilters"></app-filter>

<app-multiselect-list-view
  [columnDefinition]="columnDefinition"
  [itemsSource]="itemsSource"
  [contextMenuDefinition]="contextMenuDefinition"
  [menuDefinition]="menuDefinition"
  [preferencesKey]="preferencesKey"
  (rowClick)="onRowClicked($event)"
  [isToolbarSticky]="true"
>
</app-multiselect-list-view>
